<template>
  <div class="resume-item">
    <div class="resume-item__label">
      <slot name="label_sx"></slot>
      <slot name="icon"></slot>
    </div>
    <div class="resume-item__label">
      <slot name="label_dx"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'resume-item',

  components: {
  },

  props: {
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {

  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .resume-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: $font-size-md;
    margin-bottom: 2px;

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      display: flex;
      align-items: center;
      overflow: hidden;
    }
  }

</style>